import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppInfoService {

  public get title() {
    return environment.nomeApp;
  }

  public get subtitle() {
    return environment.sottotitolo;
  }

  public get altCaption() {
    return environment.altCaption;
  }
}
